import type React from 'react';

import { Link } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../../../../config';
import Functions from '../../../../functions';
import IndexUtil from '../../../lib/IndexUtil';
import type { ItemBasicIndex } from '../../../lib/ItemUtil';

interface Props {
    lang: MultiLang;
    index: ItemBasicIndex[];
    type: BrainAtlasType;
}

const ItemIndex: React.FC<Props> = (props) => {
    const { lang, index, type } = props;
    if (index.length === 0) {
        return null;
    }
    const elements = index.map((value, idx) => {
        const evenodd = idx % 2 === 0 ? 'even' : 'odd';
        const url = IndexUtil.getUrl(type, value.index_id);
        return (
            <tr key={value.index_id}>
                <td className={evenodd}>
                    <Link to={url}>{Functions.mlang(value.title, lang)}</Link>
                </td>
            </tr>
        );
    });
    return (
        <table>
            <tbody>{elements}</tbody>
        </table>
    );
};

export default ItemIndex;
